import { CalculateFestival } from '@/domain/impact-calculate-festival/entities/calculate-festival.entity';

import { CalculateFestivalCo2Mapper } from '../co2/mapper';
import { CalculateFestivalEnvMapper } from '../env/mapper';
import { CalculateFestivalEssMapper } from '../ess/mapper';
import { AllImpactFestivalForAllProjectsDto } from './dto.schema';

export class AllImpactFestivalForAllProjectsMapper {
  static dtoToEntity(
    dto: AllImpactFestivalForAllProjectsDto,
  ): { projectId: number; calculate: CalculateFestival }[] {
    return dto.data.map((item) => {
      return {
        projectId: item.id,
        calculate: {
          co2:
            item.results.co2 &&
            CalculateFestivalCo2Mapper.dtoToEntity(item.results.co2),
          ess:
            item.results.ess &&
            CalculateFestivalEssMapper.dtoToEntity(item.results.ess),
          env:
            item.results.env &&
            CalculateFestivalEnvMapper.dtoToEntity(item.results.env),
        },
      };
    });
  }
}
